import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const NODE_ENV = process.env.NODE_ENV;
const TEST_QUESTION = process.env.REACT_APP_TEST_QUESTION;

// endpoint URLs ---------------------------------------------
// 1.Study All
const getQuestionsByRateURL = `getNextStudyAllQuestions`;

// 2.Personalized Study (PS) by Study All: Study All restricted to user's selected chapters.
const getQuestionsByPersonalizedStudyAllURL = `getNextStudyAllPersonalizedQuestions`;

// 4.Study Qual by Study All: Enables the user to study all references from a specific Qual.
const getQuestionsByQualsURL = `getNextQualQuestions`;

// 6.Study Qual by Chapter
// this method uses the same endpoint as getQuestionsByChapter (number 10)

// 7.Study by rate user Favorite Questions
const getStudyFavoriteQuestionURL = `getNextFavoriteQuestions`;

// 8.Study by User Favorite Questions
const getStudyFavoriteQuestionURLByUser = `getNextFavoriteQuestions`;

// 9.Study by User Submitted Questions
const getStudySubmittedQuestionURL = `getNextSubmittedQuestionsNew`;

// 10.Study by Chapter (from the "By Reference" list)
const getQuestionsByChapterURL = `getNextChapterQuestions`;

// -------------------------------------------------------------

export function getContentByReferenceService(rate) {
  return axios
    .get(`${BASE_URL}/reference?rate=${rate.id}`)
    .then(({ data }) => data);
}

export function getSKTData(rateId, rank, dutyState) {
  return axios
    .get(
      `${BASE_URL}/sktData?rate=${rateId}&rank=${rank}&dutyState=${dutyState}`,
    )
    .then(({ data }) => data);
}

export function getReferencePdfPrivate(payload) {
  return axios
    .get(`${BASE_URL}/reference/getPdfUrl`, {
      params: {
        url: payload.url,
        chapterId: payload.chapterId,
      },
    })
    .then(({ data }) => data);
}

export function getPostExamChecklistPdfService() {
  return axios
    .get(`${BASE_URL}/postExamChecklist/pdf`)
    .then(({ data }) => data);
}

export function getContentByWarfareQualsService(rate) {
  return axios.get(`${BASE_URL}/quals`).then(({ data }) => data);
}

export function qualFromIdService(qual) {
  return axios
    .get(`${BASE_URL}/reference?qual=${qual.id}`)
    .then(({ data }) => data);
}

export function getContentByStudyAllService(rate, studyProgram) {
  if (
    TEST_QUESTION &&
    TEST_QUESTION !== 'null' &&
    TEST_QUESTION !== 'false' &&
    NODE_ENV === 'development'
  ) {
    return axios
      .post(`${BASE_URL}/nextQuestion?questionId=${TEST_QUESTION}`)
      .then(({ data }) => data);
  }
  return axios
    .post(
      `${BASE_URL}/nextQuestion?rateId=${rate.id}&studyProgramId=${studyProgram.id}`,
    )
    .then(({ data }) => data);
}

// -- Questions / Answers flow.

export function getQuestionsByQualsService(
  qual,
  studyProgram,
  stackedQuestions,
) {
  if (
    TEST_QUESTION &&
    TEST_QUESTION !== 'null' &&
    TEST_QUESTION !== 'false' &&
    NODE_ENV === 'development'
  ) {
    return axios
      .post(`${BASE_URL}/nextQuestion?questionId=${TEST_QUESTION}`)
      .then(({ data }) => data);
  }
  const url = getQuestionsByQualsURL;
  return axios
    .post(`${BASE_URL}/${url}?qualId=${qual}&studyProgramId=${studyProgram}`, {
      stackedQuestions,
    })
    .then(({ data }) => data);
}

export function getQuestionsByChapterService(
  chapter,
  studyProgram,
  stackedQuestions,
) {
  if (
    TEST_QUESTION &&
    TEST_QUESTION !== 'null' &&
    TEST_QUESTION !== 'false' &&
    NODE_ENV === 'development'
  ) {
    return axios
      .post(`${BASE_URL}/nextQuestion?questionId=${TEST_QUESTION}`)
      .then(({ data }) => data);
  }
  const url = getQuestionsByChapterURL;
  return axios
    .post(
      `${BASE_URL}/${url}?chapterId=${chapter}&studyProgramId=${studyProgram}`,
      {
        stackedQuestions,
      },
    )
    .then(({ data }) => data);
}

export function getQuestionsByRateService(stackedQuestions) {
  if (
    TEST_QUESTION &&
    TEST_QUESTION !== 'null' &&
    TEST_QUESTION !== 'false' &&
    NODE_ENV === 'development'
  ) {
    return axios
      .post(`${BASE_URL}/nextQuestion?questionId=${TEST_QUESTION}`)
      .then(({ data }) => data);
  }
  const url = getQuestionsByRateURL;
  return axios
    .post(`${BASE_URL}/${url}`, {
      stackedQuestions,
    })
    .then(({ data }) => data);
}

export function getQuestionsByPersonalizedStudyAllService(
  studyProgram,
  stackedQuestions,
) {
  if (
    TEST_QUESTION &&
    TEST_QUESTION !== 'null' &&
    TEST_QUESTION !== 'false' &&
    NODE_ENV === 'development'
  ) {
    return axios
      .post(`${BASE_URL}/nextQuestion?questionId=${TEST_QUESTION}`)
      .then(({ data }) => data);
  }
  return axios
    .post(
      `${BASE_URL}/${getQuestionsByPersonalizedStudyAllURL}?studyProgramId=${studyProgram.id}`,
      { stackedQuestions },
    )
    .then(({ data }) => data);
}

export function sendAnswerService(answer) {
  if (!TEST_QUESTION || TEST_QUESTION === 'null' || TEST_QUESTION === 'false') {
    return axios
      .post(`${BASE_URL}/answerQuestion/${answer.questionId}`, answer)
      .then(({ data }) => data);
  }
  return 'Test Question';
}

export function favoriteQuestionService(questionId, userId) {
  return axios
    .post(`${BASE_URL}/favoriteQuestion`, {
      questionId,
      userId,
    })
    .then(({ data }) => data);
}

export function removeFavoriteQuestionService(questionId, userId) {
  return axios
    .post(`${BASE_URL}/removeFavoriteQuestions`, {
      questionsId: questionId,
      userId,
    })
    .then(({ data }) => data);
}

export function getStudyFavoriteQuestionService(stackedQuestions) {
  const url = getStudyFavoriteQuestionURL;
  return axios
    .post(
      `${BASE_URL}/${url}`,
      {
        stackedQuestions,
      },
      {
        params: {
          byUser: false,
        },
      },
    )
    .then(({ data }) => data);
}

export function getStudyMyFavoriteQuestionService(stackedQuestions) {
  const url = getStudyFavoriteQuestionURLByUser;
  return axios
    .post(
      `${BASE_URL}/${url}`,
      {
        stackedQuestions,
      },
      {
        params: {
          byUser: true,
        },
      },
    )
    .then(({ data }) => data);
}

export function getStudySubmittedQuestionService(stackedQuestions) {
  return axios
    .post(
      `${BASE_URL}/${getStudySubmittedQuestionURL}`,
      {
        stackedQuestions,
      },
      {
        params: {
          byUser: false,
        },
      },
    )
    .then(({ data }) => data);
}

export function getStudyMySubmittedQuestionService(stackedQuestions) {
  return axios
    .post(
      `${BASE_URL}/${getStudySubmittedQuestionURL}`,
      {
        stackedQuestions,
      },
      {
        params: {
          byUser: true,
        },
      },
    )
    .then(({ data }) => data);
}

export function getUserAnswersServices(payload) {
  return axios
    .get(`${BASE_URL}/userAnswers`, { params: payload })
    .then(({ data }) => data);
}

export function updateUserAnswersServices(payload) {
  return axios
    .patch(`${BASE_URL}/updateResetChapter/`, payload)
    .then(({ data }) => data);
}

export function checkChapterInReviewServices(value) {
  return axios
    .post(`${BASE_URL}/checkChapterInReview`, value)
    .then(({ data }) => data);
}

export function chapterStatusServices(userId, chapterId) {
  return axios
    .post(`${BASE_URL}/chapterStatus`, { userId, chapterId })
    .then(({ data }) => data);
}

export function getAudioPlaylist(chapterId) {
  return axios
    .get(`${BASE_URL}/audio/getPlayListForChapter/${chapterId}`)
    .then(({ data }) => data);
}

export async function getAudioPlaylistsProgress(chapterIds) {
  return axios
    .get(`${BASE_URL}/audio/progress`, {
      params: { chapterIds: chapterIds.join(',') },
    })
    .then(({ data }) => data);
}

export async function updateAudioPlaylistProgress(
  chapterId,
  nextQuestionId,
  status,
) {
  return axios
    .post(`${BASE_URL}/audio/progress`, { chapterId, nextQuestionId, status })
    .then(({ data }) => data);
}

export function resetChapterService(payload) {
  return axios
    .post(`${BASE_URL}/resetChapter/`, payload)
    .then(({ data }) => data);
}
